// export default ['API_URL','$http', urlService]
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../apiservices/apiUrl.provider';

@Injectable({ providedIn: 'root' })
export class urlService {

	constructor(
		@Inject(API_URL) private API_URL: string,
		private $http: HttpClient,
	){

	}
	/**
	 * Given a URL, executes the download of the file.
	 */
	download(url: string, name = "file", replaceProtocol = true) {
		var link = document.createElement("a");
		link.download = name;
		link.href = replaceProtocol ? this.replaceUrlProtocol(url): url;
		link.click();
	}

	downloadBlob(fileUrl) {
		return this.$http.get(fileUrl, { responseType: 'arraybuffer' }).toPromise();
	}

	/**
	 * Allows to download any javascript type as a JSON file.
	 * @param {any} data any javascript type.
	 * @param {string} name optional, name for the file, do not include extension (.json).
	 */
	downloadAsJson(data, name = "") {
		const link = document.createElement("a");
		link.download = name ? `${name}.json`: 'file.json';
		link.href = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(data))}`;
		link.click();
	}

	/**
	 * Replaces the HTTP protocol of a given URL for the protocol used by the API URL.
	 * @param {String} url
	 * @returns {String}
	 */
	replaceUrlProtocol(url) {
		var apiProtocol = new URL(this.API_URL).protocol;
		var newUrl = new URL(url);
		newUrl.protocol = apiProtocol;
		return newUrl.href;
	}
}
